function island(name, overrides = {}) {
    return {
        name,
        payloadId: overrides.payloadId ?? `${name}-init`,
        rootId: overrides.rootId ?? `${name}-root`,
    };
}
export const Islands = {
    /**
     * Bootstrap config. `payloadId` is overridden: this island predates the naming
     * convention and its id is read by an already-deployed bundle.
     */
    config: island("config", { payloadId: "__config" }),
    /** /dashboard Overview charts. Renders into per-chart containers, not `rootId`. */
    /** Google Ads enhanced-conversion event. Payload only — no component. */
    conversionTag: island("conversion-tag"),
    /** Experimental vector-search page (/labs/search). */
    labsSearch: island("labs-search"),
    /** Front-page Advanced search box (axes/negative/classic) under the search bar. */
    frontAdvanced: island("front-advanced"),
    /**
     * Reverse image search on Browse. TWO islands for one feature, because it has two mount
     * points far apart in the document — the button beside the search input, the chip at the
     * top of the filter sidebar. They share state through
     * `apps/pictufy-web/src/features/searchImage/store.ts`, not through a payload, so both
     * carry an empty one.
     */
    searchImage: island("search-image"),
    searchImageChip: island("search-image-chip"),
    /**
     * Content-loader seed state. Payload only — the loader renders into the
     * container named by `payload.targetId`, not into this island's `rootId`.
     */
    loader: island("loader"),
};
//# sourceMappingURL=islands.js.map